import React from 'react';
import LoadingSpinner from '../ui/LoadingSpinner';
import { pageStyles } from '../../config/theme';

interface LoadingPageProps {
  title?: string;
  subtitle?: string;
}

/**
 * LoadingPage component that provides consistent loading UI
 * Uses the application's theme configuration for styling
 */
const LoadingPage: React.FC<LoadingPageProps> = ({ 
  title = 'Loading...',
  subtitle = 'Please wait'
}) => {
  return (
    <div style={pageStyles.gradientBackground}>
      <div style={pageStyles.container}>
        <div style={pageStyles.formContainer}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem 0',
            textAlign: 'center'
          }}>
            <LoadingSpinner size="lg" />
            <p style={{
              ...pageStyles.subtitle,
              marginTop: '1rem',
              fontSize: '1.125rem',
              fontWeight: '500'
            }}>
              {title}
            </p>
            <p style={{
              ...pageStyles.subtitle,
              marginTop: '0.5rem',
              fontSize: '0.875rem',
              opacity: 0.8
            }}>
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
